module.exports = __webpack_public_path__ + "images/category_lp/furniture/assessment_achievements/4_aabcf4ee73403b57737a99ce0bf53111.png";